var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeatLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.286 9.407h6.429c.197 0 .357-.16.357-.357V2.622a.357.357 0 00-.357-.357H4.286a.357.357 0 00-.357.357V9.05c0 .197.16.357.357.357zm6.429 1.429c.986 0 1.786-.8 1.786-1.786V2.622c0-.987-.8-1.786-1.786-1.786H4.286c-.986 0-1.785.8-1.785 1.786V9.05c0 .986.799 1.786 1.785 1.786h6.429z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.572 10.841V5.836H15.001v5.023c0 .681-.481 1.133-.929 1.403-.465.28-1.08.485-1.747.638-1.345.307-3.1.446-4.828.435-1.729-.01-3.482-.17-4.823-.482-.665-.154-1.275-.357-1.736-.626-.43-.252-.937-.688-.937-1.368V5.836H1.43v4.983a.81.81 0 00.229.174c.28.164.731.328 1.339.47 1.203.28 2.843.434 4.507.444 1.665.01 3.302-.125 4.502-.4.606-.139 1.05-.302 1.328-.469.171-.103.223-.172.237-.197zm.005-.01l-.003.006.003-.006zM1.42 10.803l.002.005-.002-.005z",
    fill: "#757575"
  })));
}
export default SvgSeatLeft;